import { PaginationModel } from './PaginationModel'
export class EntitiesPaginatedModel<T> {
    entities: T[] = []
    pagingInfo: PaginationModel = new PaginationModel()
}
